/**
 * useIsEU
 */

import { useCallback } from 'react';
import {
    Queries,
    Mutations,
    ApolloLib,
} from 'bdvp-graphql';
import { getIsEU } from '../../utils';
import useMediaConfig from '../config/useMediaConfig';

const {
    useQuery,
    useMutation,
} = ApolloLib;
const {
    GET_IS_EU,
} = Queries;
const {
    SET_IS_EU,
} = Mutations;

const useIsEU = () => {

    const config = useMediaConfig();
    const [setIsEuMutation] = useMutation(SET_IS_EU);
    const loadIsEU = useCallback(
        async() => {

            const isEU = await getIsEU(config);

            setIsEuMutation({
                variables: {
                    isEU,
                },
            });

        },
        [
            setIsEuMutation,
            config,
        ]
    );

    const {
        loading,
        data = {},
        error,
    } = useQuery(GET_IS_EU);
    const { isEU } = data;

    return {
        loadIsEU,
        loading,
        isEU,
        error,
    };

};

export default useIsEU;
